<template>
  <div class="slide_banner">
    <el-carousel
      trigger="click"
      :height="autoHeight"
      arrow="never"
      :autoplay="false"
      style="overflow: hidden"
    >
      <el-carousel-item>
        <img
          src="@/assets/images/new-img/home/header-bg.jpg"
          class="bannerImg"
        />

        <div class="slide_text_content">
          <div class="slide_box">
            <!-- 为千万家餐厅提供食材订购及服务 -->
            <p class="slide_title">国内餐饮供应链杰出服务商</p>
            <p class="slide_description">
              <span>源头优选</span>
              <span>系统高效</span>
              <span>物流闪送</span>
              <span>采购便捷</span>
            </p>
          </div>
        </div>
      </el-carousel-item>
      <!-- <el-carousel-item v-for="(item,index) in imgList" :key="index">
        <img :src="item.src" class="bannerImg" />
        <div class="slide_box">
          <p class="slide_title">中国餐饮供应链杰出服务商</p>
          <p class="slide_description">
            <span>源头优选</span>
            <span>系统高效</span>
            <span>物流闪送</span>
            <span>采购便捷</span>
          </p>
        </div>
      </el-carousel-item>-->
    </el-carousel>

    <div class="slide_text_buttons">
      <div class="slide_but" v-for="(item, index) in buttonList" :key="index">
        <router-link :to="item.href">
          <div class="content">
            <img :src="item.imgSrc" />
            {{ item.name }}
          </div>

          <p class="desc">
            {{ item.name }}
            <br />
            <span>{{ item.desc }}</span>
          </p>
        </router-link>
      </div>
    </div>

    <div class="slide_telephone">
      <div class="round">
        <img src="@/assets/images/slide/slide_05.png" />
      </div>
      <div class="tel">{{ $concatPhone || "4006-135-135" }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slide",
  data() {
    return {
      autoHeight: "",
      imgList: [
        {
          src:
            "https://img-oss.yunshanmeicai.com/cfile/83017918cdc6c9c1ec96b6efe341c522.jpg",
        },
        {
          src:
            "https://img-oss.yunshanmeicai.com/cfile/c6f5d3a6a9b448b5383130bf02c356a9.jpg",
        },
        {
          src:
            "https://img-oss.yunshanmeicai.com/cfile/f5bf56efeb79841aaa29ea8ce519a31c.jpg",
        },
      ],
      buttonList: [
        {
          href: "/download_app",
          imgSrc: require("@/assets/images/slide/slide_01.png"),
          name: "美菜商城",
          desc: "快速了解采购流程",
        },
        // {
        //   href: "/partner",
        //   imgSrc: require("@/assets/images/slide/slide_02.png"),
        //   name: "城市代理",
        //   desc: "新开站点增值收益"
        // },
        // {
        //   href: "/county",
        //   imgSrc: require("@/assets/images/new-img/company/county.png"),
        //   name: "县域招募",
        //   desc: "开拓万亿级县域市场"
        // },
        // {
        //   href: "/cooperation",
        //   imgSrc: require("@/assets/images/slide/slide_03.png"),
        //   name: "供应商合作",
        //   desc: "为千万餐厅供给食材",
        // },
        {
          href: "/driver",
          imgSrc: require("@/assets/images/slide/slide_04.png"),
          name: "司机报名",
          desc: "为万千商户配送货物",
        },
        {
          href: "/commonweal",
          imgSrc: require("@/assets/images/slide/slide_06.png"),
          name: "我有滞销菜",
          desc: "精准扶贫采购计划",
        },
      ],
    };
  },
  methods: {
    getAutoHeight() {
      let _w =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.autoHeight = _w - 60 + "px";
    },
  },
  mounted() {
    this.getAutoHeight();
  },
};
</script>

<style lang="scss" scoped>
.slide_banner {
  width: 100%;
  position: relative;
  min-width: 1200px;
  overflow: hidden;
}
.bannerImg {
  width: 100%;
  height: inherit;
  min-height: 360px;
  min-width: 1400px;
}
.slide_text_content {
  position: absolute;
  bottom: 110px;
  left: 45px;
}
.slide_box {
  .slide_title {
    font-size: 50px;
    color: #ffffff;
    margin: 0;
  }
  .slide_description {
    margin-top: 15px;
    margin-bottom: 25px;
    span {
      display: inline-block;
      margin-right: 20px;
      font-size: 24px;
      color: #ffffff;
      text-shadow: 0 2px 2px rgba(0, 0, 0, 1);
    }
  }
}

.slide_text_buttons {
  position: absolute;
  bottom: 50px;
  left: 45px;
  z-index: 10;
  .slide_but {
    display: inline-block;
    width: 154px;
    height: 54px;
    overflow: hidden;
    border-radius: 27px;
    background-color: #f5f5f5;
    margin-right: 7px;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    background-color: #75bc46;
    &:hover a div {
      margin-top: -55px;
    }
    .content {
      font-size: 18px;
      color: #4a4a4a;
      text-align: center;
      height: 55px;
      line-height: 55px;
      background-color: #fff;
      img {
        margin-right: 5px;
        vertical-align: text-top;
      }
    }
    .desc {
      padding-top: 9px;
      color: #fff;
      font-size: 18px;
      text-align: center;
      span {
        font-size: 12px;
      }
    }
  }
}
.slide_telephone {
  position: absolute;
  bottom: 10px;
  right: 50px;
  color: #fff;
  display: flex;
  height: 55px;
  z-index: 10;
  .round {
    background-color: #f5f5f5;
    border-radius: 30px;
    padding: 10px 7px;
    width: 55px;
    height: 55px;
    vertical-align: middle;
    margin-right: 10px;
  }
  .tel {
    height: 55px;
    line-height: 55px;
    font-size: 24px;
  }
}
</style>

<style lang="scss">
.el-carousel__indicators {
  left: 0% !important;
  transform: translateX(0%) !important;
  margin-left: 280px !important;
}
</style>

